import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Home as HomeIcon, Building2, MessageSquare, Gavel, ArrowLeft } from 'lucide-react';

const AdminNav = () => {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
  const navItems = [
    { path: '/admin', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
    { path: '/admin/properties', icon: <Building2 size={20} />, label: 'Properties' },
    { path: '/admin/enquiries', icon: <MessageSquare size={20} />, label: 'Enquiries' },
    { path: '/admin/bids', icon: <Gavel size={20} />, label: 'Bids' },
  ];
  
  return (
    <div className="bg-white border-b-2" style={{ borderColor: '#e8e8e8' }}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center space-x-6">
            <Link to="/" className="flex items-center space-x-2 text-sm" style={{ color: '#636e72' }}>
              <ArrowLeft size={16} />
              <span>Back to Site</span>
            </Link>
            <div className="h-6 w-px" style={{ background: '#e8e8e8' }}></div>
            <h2 className="text-xl font-bold" style={{ color: '#1a1a2e' }}>Admin Panel</h2>
          </div>
          
          <nav className="flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition ${
                  isActive(item.path)
                    ? 'btn-primary-custom text-white'
                    : 'hover:bg-gray-100'
                }`}
                style={!isActive(item.path) ? { color: '#636e72' } : {}}
              >
                {item.icon}
                <span className="font-medium">{item.label}</span>
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default AdminNav;